<template>
  <div class="accountWrap">
    <div v-if="this.$route.path === '/personal/myAccount'" class="toUp">
      <h3>
        账户充值
        <a href="javaScript:" class="applyStatus fr blue">
          兑换比例：1元 =100源币
        </a>
      </h3>
      <div class="upbox">
        <p class="toupTitle">
          账户余额：{{ userInfo.yuanBi }} 源币 | {{ userInfo.coin }} 赠币
        </p>
        <dl class="paybox clearfix">
          <dt class="fl">
            充值方式：
          </dt>
          <dd class="fl">
            <ul class="clearfix payType">
              <li class="fl" style="border:none" @click="choosePayType(1)">
                <img
                  v-if="payChecked == 2"
                  src="~img/account/weixin(1).png"
                  alt=""
                />
                <img
                  v-if="payChecked == 1"
                  src="~img/account/weixin(2).png"
                  alt=""
                />
              </li>
              <li class="fl" style="border:none" @click="choosePayType(2)">
                <img
                  v-if="payChecked == 1"
                  src="~img/account/pay(1).png"
                  alt=""
                />
                <img
                  v-if="payChecked == 2"
                  src="~img/account/pay(2).png"
                  alt=""
                />
              </li>
            </ul>
          </dd>
        </dl>
        <dl class="paybox clearfix">
          <dt class="fl">充值金额：</dt>
          <dd class="fl">
            <ul class="clearfix">
              <li
                class="fl"
                v-for="item in payNum"
                :key="item.money"
                @click="choosePayMoney(item.money, item.yuanBi)"
              >
                {{ item.money }}元
                <img
                  v-show="item.money == choosePayNum"
                  class="chooseNum"
                  src="~img/account/checked.png"
                  alt=""
                />
              </li>
            </ul>
          </dd>
        </dl>
        <dl class="paybox clearfix" style="margin-bottom: 55px">
          <dt class="fl">其他金额：</dt>
          <dd class="fl">
            <input
              type="text"
              v-model="myPayNum"
              @focus="goMyNum"
              @keyup="changeBiNum"
              placeholder="最低充值1元最高充值1000"
            />
            <span>元</span>
          </dd>
        </dl>
        <div class="payOption">
          <p>可获得{{ giveYuanBi }}源币</p>
          <button @click="goPay">
            去付款
          </button>
          <div>
            <router-link to="/personal/myAccount/rechargeRecord">
              充值记录
            </router-link>
            |
            <router-link to="/personal/myAccount/expenseRecord"
              >消费记录</router-link
            >
          </div>
        </div>
        <div class="hintbox">
          <h4>温馨提示</h4>
          <p>
            1.人民币：源币兑换比例为：1元=100源币，源币属于虚拟商品，一经购买不得退换；
          </p>
          <p>2.充值获得源币仅限当前网站内使用；</p>
          <p>3.工作时间：周一到周日9:00-22:00；</p>
          <p>
            4.若充值后账户余额长时间无变化，请记录您的用户ID后联系客服
            客服QQ：1655338768，微信：zhangwencps
          </p>
        </div>
        <div class="imgbox" v-show="payImg">
          <div class="goSuccessbox">
            <img
              class="closepay"
              src="~img/close.png"
              @click="closePay"
              alt=""
            />
            <div class="orderbox clearfix">
              <img class="fl" src="~img/personal/WePayLogo.png" alt="" />
              <p class="fl">
                订单号：{{ orderNo }}
                <span style="margin-right:20px;display:inline-block"></span
                >金额：{{ payMoney }}元
              </p>
            </div>
            <img
              style="width:300px;margin: 20px 0;"
              ref="codeimg"
              alt=""
            /><br />
            <img style="width:230px" src="~img/personal/weixins.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
    <router-view></router-view>
  </div>
</template>

<script>
import { getuserInfo } from "@/api/login";
import { payMoney, payMoneyList, wxpayMoney, payisSuccess } from "apiurl/pay";
import { CONSUME } from "apiurl/index.js";
import { getToken } from "utils/storage";
import axios from "axios";
export default {
  data() {
    return {
      payNum: [],
      payChecked: 1,
      payImg: false,
      choosePayNum: 10,
      myPayNum: null,
      giveYuanBi: 0,
      userInfo: Object,
      timer: null,
      orderNo: "",
      payMoney: 0,
      successnum: 0,
      allUrl: "",
      ApplyInfo: {
        isShow: false,
        title: "等待支付",
        content: "请在新打开的页面中完成支付",
        hint: "* 充值遇到问题，请联系客服",
        sure: "支付完成",
        cancle: "关闭"
      }
    };
  },
  created() {
    this.allUrl = CONSUME;
    this.$nextTick(() => {
      this.getlist();
      this.getInfo();
    });
  },
  methods: {
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      this.userInfo = res.data;
    },
    // 选择充值方式
    choosePayType(id) {
      this.payChecked = id;
    },
    // 充值
    async goPay() {
      let money = this.giveYuanBi;
      this.payMoney = (money / 100).toFixed(2);
      /* this.giveYuanBi >= 100 && */
      if (this.giveYuanBi >= 100 && this.giveYuanBi <= 100000) {
        if (this.payChecked == 2) {
          let res = await payMoney({
            amount: money
          });
          if (res.success) {
            this.orderNo = res.data.topUpId;
            let form = res.data.orderInfo;
            let routerData = this.$router.resolve({
              path: "/alipay",
              query: { htmls: form }
            });
            window.open(routerData.href, "_blank");
            this.ApplyInfo.isShow = true;
          }
        } else {
          let wxres = await wxpayMoney({
            amount: this.pro ? money : money / 100
          });
          if (wxres.success) {
            this.payImg = true;
            this.orderNo = wxres.data.orderNo;
            this.$refs["codeimg"].setAttribute(
              "src",
              `${CONSUME}/core/pay/qrCode/get?codeUrl=${wxres.data.codeUrl}&amount=${money}`
            );
            this.timer = setInterval(() => {
              this.successnum++;
              if (this.successnum > 20) {
                clearInterval(this.timer);
              }
              this.getIsSuccess(money);
            }, 5000);
          }
        }
      } else {
        this.$message({
          message: "请输入大于1的整数",
          type: "error"
        });
        this.myPayNum = null;
      }
    },
    getIsSuccess(money) {
      let $this = this;
      axios
        .get(`${CONSUME}/core/pay/query/order`, {
          params: { orderNo: this.orderNo, account: money },
          headers: {
            Authorization: "Bearer " + getToken()
          }
        })
        .then(res => {
          let payInfo = res.data;
          if (payInfo.success) {
            if (payInfo.data.paySuccess) {
              clearInterval(this.timer);
              $this.payImg = false;
              $this.$message({
                message: "充值成功",
                type: "success"
              });
              $this.getInfo();
            }
          }
        }, 20000)
        .catch(error => {
          console.log("tag", error);
        });
    },
    // 选择金额
    choosePayMoney(num, bi) {
      this.choosePayNum = num;
      this.myPayNum = null;
      this.giveYuanBi = bi;
    },
    // 自定义
    goMyNum() {
      this.choosePayNum = 0;
    },
    // 获取充值金额列表
    async getlist() {
      let res = await payMoneyList({ channelId: 1 });
      this.payNum = res.data.normal.gradeList;
      this.giveYuanBi = this.payNum[0].yuanBi;
      this.choosePayNum = this.payNum[0].money;
    },
    // 自定义输入
    changeBiNum() {
      if (
        (this.myPayNum != null &&
          this.myPayNum.toString().substr(0, 1) == "0") ||
        this.myPayNum % 1 !== 0
      ) {
        this.giveYuanBi = 0;
        //this.giveYuanBi = this.myPayNum * 100;
      } else {
        this.giveYuanBi = this.myPayNum * 100;
      }
    },
    // 关闭
    closePay() {
      this.payImg = false;
      clearInterval(this.timer);
    },
    //支付充值弹框
    passbind(val) {
      if (val) {
        payisSuccess({ topUpId: this.orderNo }).then(res => {
          if (res.success) {
            this.$router.go(-1);
          }
        });
      }
      this.getInfo();
    }
  },
  destroyed() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/styles/cominxin.styl'
.blue
    color #48A2DF
.toUp
    .upbox
        margin 30px 0 0 40px
        .toupTitle
            color rgba(154, 154, 154, 1)
            font-size 14px
            margin-bottom 24px
        .paybox
            margin-bottom 24px
            dt
                font-size 14px
                font-weight 600
                color rgba(154, 154, 154, 1)
                margin-right 15px
            dd
                li
                    width 80px
                    height 40px
                    background rgba(255, 255, 255, 1)
                    border-radius 3px
                    border 1px solid rgba(233, 233, 233, 1)
                    margin-right 20px
                    font-size 16px
                    font-weight 600
                    color rgba(152, 152, 152, 1)
                    line-height 40px
                    text-align center
                    cursor pointer
                    position relative
                    .chooseNum
                        position absolute
                        bottom 0px
                        right 0px
                .payType
                    li
                        width 150px
                        img
                            width 100%
                input
                    width 239px
                    height 40px
                    background rgba(255, 255, 255, 1)
                    border-radius 3px
                    border 1px solid rgba(233, 233, 233, 1)
                    padding-left 20px
                    box-sizing border-box
                    placeMain(#D9D9D9, 16px)
                    color #989898
                span
                    display inline-block
                    height 40px
                    color #9A9A9A
                    margin-left 5px
                    font-size 14px
        .payOption
            margin-left 86px
            margin-bottom 30px
            p
                font-size 14px
                font-weight 600
                color rgba(72, 162, 223, 1)
                margin-bottom 10px
                margin-left 9px
            button
                width 159px
                height 40px
                background rgba(72, 162, 223, 1)
                border-radius 4px
                color #ffffff
                border none
            div
                margin-top 10px
                font-size 14px
                font-weight 600
                color rgba(168, 168, 168, 1)
                margin-bottom 30px
                margin-left 10px
                a
                    font-size 14px
                    font-weight 600
                    color rgba(168, 168, 168, 1)
                    line-height 20px
.imgbox
    position fixed
    left 0
    top 0
    width 100vw
    height 100vh
    background rgba(0, 0, 0, 0.4)
    z-index 1000
    .goSuccessbox
        width 740px
        height 450px
        padding 40px 30px
        background #fff
        border-radius 20px
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        margin auto
        text-align center
        .orderbox
            img
                width 100px
            p
                line-height 30px
                margin-left 15px
        .closepay
            position absolute
            right 30px
            top 30px
.hintbox
    font-size 12px
    color: #9a9a9a;
    line-height 30px
    margin-top 67px
</style>
